/**
 * Der Stern „NEU“ am Umschalter und die Karte „So funktioniert dein Guide“ sind EINE Erklaerung (Partner): ein Klick auf den Stern oeffnet dieselbe Karte, kein zweites
 * Textfeld. Die Karte steht im GuidePanel, der Stern in der Hofansicht — dieses kleine Ereignis verbindet sie, ohne dass eine die andere kennt. Nichts wird gespeichert.
 */
const EREIGNIS = 'cui-erklaerkarte-oeffnen';
export function oeffneErklaerkarte(): void { window.dispatchEvent(new CustomEvent(EREIGNIS)); }
export function beiErklaerkarteOeffnen(fn: () => void): () => void {
  window.addEventListener(EREIGNIS, fn);
  return () => window.removeEventListener(EREIGNIS, fn);
}
